import type { Resource } from '../../';
export const search_box_frame_suggestedTerms: Resource = {"default":"Suggested Search Terms"};
